
import { defineComponent } from 'vue';

import Header from './component/header.vue';

export default defineComponent({
  name: 'MainLayout',
  components: {
    Header,
  },
  setup() {
    return {};
  },
});
